/**
 * [PORTABLE] Onboarding HTTP service. Pure network layer — no React.
 * Target path in main project: src/features/onboarding/api/onboarding.service.ts
 */
import { onboardingApiClient } from "@/api/config/api-client";
import { ONBOARDING_ENDPOINTS } from "@/api/config/api-endpoints";
import type {
  GenerationStatusResponse,
  OnboardingLevel,
  OnboardingProgress,
  Pillar,
  SelfieUploadResponse,
  StartGenerationInput,
  StartGenerationResponse,
} from "../types/onboarding.types";

/**
 * Zarf Açıcı (Unwrapper) Yardımcı Fonksiyon
 */
const unwrap = (res: any) => {
  // 🚀 EKLENEN KRİTİK KONTROL: Senin api-client'ın 400'lü hataları başarılı gibi resolve ediyor.
  // Eğer gelen cevapta "success: false" yazıyorsa, React Query'nin bunu 
  // "onError" (Hata) bloğuna düşürmesi için bunu zorla bir hata olarak fırlatıyoruz!
  if (res?.success === false) {
    throw res;
  }
  
  return res?.data !== undefined ? res.data : res;
};

export const onboardingService = {
  getLevels: (pillar?: Pillar): Promise<OnboardingLevel[]> => {
    // NOT: Template literal kullanımı için backtick (`) eklendi
    const qs = pillar ? `?pillar=${encodeURIComponent(pillar)}` : "";
    return onboardingApiClient
      .get<any>(`${ONBOARDING_ENDPOINTS.levels}${qs}`)
      .then(unwrap);
  },

  getProgress: (): Promise<OnboardingProgress> => 
    onboardingApiClient
      .get<any>(ONBOARDING_ENDPOINTS.progress)
      .then(unwrap),

  skipOnboarding: (): Promise<{ success: boolean }> =>
    onboardingApiClient
      .post<any>(ONBOARDING_ENDPOINTS.skip, {})
      .then(unwrap),

  uploadSelfie: (file: File): Promise<SelfieUploadResponse> => {
    const formData = new FormData();
    formData.append("file", file);
    return onboardingApiClient
      .post<any>(ONBOARDING_ENDPOINTS.selfieUpload, formData)
      .then(unwrap);
  },

  startGeneration: (input: StartGenerationInput): Promise<StartGenerationResponse> =>
    onboardingApiClient
      .post<any>(ONBOARDING_ENDPOINTS.generate, {
        pillar: input.pillar,
        levelId: input.levelId,
        ...(input.prompt !== undefined ? { prompt: input.prompt } : {}),
        ...(input.selfieLibraryItemId
          ? { selfieLibraryItemId: input.selfieLibraryItemId }
          : {}),
      })
      .then(unwrap),

  getGenerationStatus: (generationId: string): Promise<GenerationStatusResponse> =>
    onboardingApiClient
      .get<any>(ONBOARDING_ENDPOINTS.status(encodeURIComponent(generationId)))
      .then(unwrap),

  getBillingHistory: (): Promise<any> =>
  onboardingApiClient
    // Dikkat: Bu endpoint /onboarding altında değil, ana api'nin altında.
    // Bu yüzden doğrudan absolute veya relative path verebiliriz.
    .get<any>("/subscription/billing-history")
    .then(unwrap),
};